export const PORTAL_ROLE = 'super_admin';
export const ALLOWED_ROLE_IDS = [1];

export function isRoleAllowed(roleId) {
  return ALLOWED_ROLE_IDS.includes(Number(roleId));
}

export function clearPortalSession() {
  localStorage.removeItem('cohToken');
  localStorage.removeItem('portal_role');
  localStorage.removeItem('username');
  localStorage.removeItem('role_id');
  localStorage.removeItem('path');
  localStorage.removeItem('userInfo');
}
